import React from 'react';

import classes from './Footer.module.css';
import {Container, Row, Col} from "reactstrap";



const Footer  = props => {
  return (
    <footer className={classes.Footer}>
      <Container>
        <Row>
          <Col md="6" className={classes.row}>
            <p>© 2021 - Soy Mentor - Universidad Tecmilenio</p>
          </Col>
          <Col md="6" className={classes.row} style={{justifyContent: "flex-end"}}>
            <p><a className={classes.text} target="_blank" href="/Home/AvisoPrivacidadAlumnos">Aviso de privacidad alumnos</a></p>
            <p><a className={classes.text} target="_blank" href="/Home/AvisoPrivacidadMentores">Aviso de privacidad mentores</a></p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
};

export default Footer;
